import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  content: {
    margin: `${theme.spacing(3)}px ${-theme.spacing(1)}px`,
  },
  openModalBtn: {
    cursor: 'pointer',
    color: '#78909C',
    '& strong': {
      color: '#072D83',
      fontWeight: 600,
    },
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    '& p': {
      fontSize: 24,
      fontWeight: 600,
      color: '#0D47A1',
    },
    [theme.breakpoints.down('md')]: {
      '& svg': {
        width: '100%',
        height: 'fit-content',
      },
    },
  },
  helperText: {
    color: '#072D83',
  },
}));
